import { ENV } from '.';
import { BASE_URL } from '../constants';

const CONST_DEV_2C2P = {
  MERCHANT_ID: '764764000002653',
  PAYMENT_URL: 'https://t.2c2p.com/RedirectV3/payment',
  PAYMENT_DESCRIPTION: 'SF SHOP'
};

const CONST_PROD_2C2P = {
  MERCHANT_ID: '764764000002653',
  PAYMENT_URL: 'https://t.2c2p.com/RedirectV3/payment',
  PAYMENT_DESCRIPTION: 'SF SHOP'
};

const MERCHANT_ID =
  ENV === 'production'
    ? CONST_PROD_2C2P.MERCHANT_ID
    : CONST_DEV_2C2P.MERCHANT_ID;

const SECRET_KEY =
  ENV === 'production' ? CONST_PROD_2C2P.SECRET_KEY : CONST_DEV_2C2P.SECRET_KEY;

const PAYMENT_URL =
  ENV === 'production'
    ? CONST_PROD_2C2P.PAYMENT_URL
    : CONST_DEV_2C2P.PAYMENT_URL;

const PAYMENT_DESCRIPTION =
  ENV === 'production'
    ? CONST_PROD_2C2P.PAYMENT_DESCRIPTION
    : CONST_DEV_2C2P.PAYMENT_DESCRIPTION;

export const CONST_2C2P = {
  VERSION: '8.5',
  PAYMENT_OPTION: 'ALL',
  MERCHANT_ID,
  SECRET_KEY,
  PAYMENT_URL,
  RESULT_URL_1: `${BASE_URL}/api/ConfirmPayment/2C2PReturn`,
  HASH_VALUE: '',
  PAYMENT_DESCRIPTION: PAYMENT_DESCRIPTION,
  ORDER_ID: '000000000001',
  AMOUNT: '000000001000',
  CURRENCY: '764'
};
